<template>
    <div>
        <div class="col">
            <div class="ibox sombra-light">
                <div class="ibox-title">
                    <h5>
                        Two Factor
                    </h5>

                </div>

                <div v-if="!puede_activar" class="alert alert-warning permanent-alert">
                    Actualmente el sistema no tiene configurado ningún canal para autenticación de dos factores. Por favor, contacte con un agente si necesita más información.
                </div>
                <div v-else>

                    <div class="ibox-content">
                        <div class="modal-body">
                            <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Two Factor</label>
                                    <div class="input-group">
                                        <div style="padding: 8px;">Desactivar</div>
                                        <input v-model="user.two_fact" type="checkbox" class="js-switch"
                                            data-switchery="true"  />
                                        <div style="padding: 8px;">Activar</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                  

                    <form @submit.prevent="accion" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6" v-if="canal_email">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                                            </div>
                                            <input class="form-control " placeholder="Nombre" type="text"
                                                v-model="user.email" disabled>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="canal_telefono">
                                    <div class="form-group">
                                        <label>Teléfono</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                                            </div>
                                            <input class="form-control " placeholder="Teléfono" type="text"
                                                v-model="user.telefono_celular">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn-primary btn" type="submit">Guardar</button>
                        </div>
                    </form>
                </div>
                </div>  
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['usuario', 'canal_telefono', 'canal_email'],
    data() {
        return {
            user: {
                email: "",
                two_fact: false
            }
        }
    },
    mounted() {
        this.user = this.usuario
    },
    methods: {
        accion() {
            if (this.user.telefono_celular == "" || this.user.telefono_celular.length < 11) {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El telefono celular debe tener 11 numeros',
                    showConfirmButton: true,
                    timer: 2000,
                });
            }

            axios.post('save_cel', { cel: this.user.telefono_celular }).then(response => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Guardado',
                    text: 'con exito',
                    showConfirmButton: true,
                    timer: 1500,
                })
            }).catch(error => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ha ocurrido un error',
                    showConfirmButton: true,
                    timer: 1000,
                });
            })
        }
    },
    watch: {
        'user.two_fact'() {
            if (this.user.two_fact && !this.puede_activar) {
                return;
            }

                axios.post('', { two_fact: this.user.two_fact }).then(response => {
                    console.log(response);
                }).catch(error => {
                    this.user.two_fact = false;
                    this.$swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Ha ocurrido un error al cambiar el estado del two factor',
                        showConfirmButton: true,
                        timer: 2000,
                    });
                });
            
        }
    },

    computed: {
        puede_activar() {
            return this.canal_telefono || this.canal_email;
        }
    }
}
</script>

<style scoped>
.permanent-alert {
    display: block !important;
    opacity: 1 !important;
    transition: none !important;
}
</style>
